import { FreeTeam24 } from "./free-team24";

export type FreeProps = {
    formattedZeroPrice: string;
    fontSize: string;
    planName: string;
};

export const Free = (props: FreeProps) => {
    return <FreeTeam24 {...props} />;
};
